import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconYoutube = (props) => (
  <Icon viewBox="0 0 29 29" fill="none" {...props}>
    <circle cx="15" cy="15" r="14.5" stroke="currentColor" />
    <path
      d="M20.7328 7.24138H9.26724C7.00573 7.24138 5.17241 9.26801 5.17241 11.768V18.232C5.17241 20.732 7.00573 22.7586 9.26724 22.7586H20.7328C22.9943 22.7586 24.8276 20.732 24.8276 18.232V11.768C24.8276 9.26801 22.9943 7.24138 20.7328 7.24138Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2178 20.0484V10.7381L20.4937 15.3932L12.2178 20.0484Z"
      fill="#E0DED8"
    />
  </Icon>
);
